export default __webpack_public_path__ + "static/media/focus-on-physical.89a0c384.svg";